import { DownloadOutlined } from '@ant-design/icons'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { downloadUrl } from '@eastcoal/common/utils/filesaver'

import { MenuButton } from '../../ui/MenuButton'

import { DownloadButtonProps } from './interface'

export const DownloadButton = ({ url, filename }: DownloadButtonProps) => {
  const { message } = useFeedback()

  const handleDownload = () => {
    if (url) {
      downloadUrl(url, filename)
    } else {
      message.warning('文件地址不存在，无法下载')
    }
  }

  return (
    <MenuButton alwaysEnabled tooltip='下载' onClick={handleDownload}>
      <DownloadOutlined />
    </MenuButton>
  )
}
